var React = require('react');

function Cross (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 9.525 8.237 5.763 5.763 8.237 9.525 12l-3.762 3.763 2.474 2.474L12 14.475l3.763 3.762 2.474-2.474L14.475 12l3.762-3.763-2.474-2.474L12 9.525Z"}));
}

Cross.defaultProps = {"xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"},"viewBox":"0 0 24 24"};

module.exports = Cross;

Cross.default = Cross;
